import { useState, useEffect } from "react";
import axios from "axios";

export const useBUSDPrice = () => {
  const [busdPrice, setBUSDPrice] = useState(null);

  const handleSetPrice = async () =>{
    const price = await axios.get("https://api.coingecko.com/api/v3/simple/price?ids=busd&vs_currencies=usd");
    setBUSDPrice(price.data.busd.usd)
  }

  useEffect(() => {
    if(busdPrice === null) handleSetPrice();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [busdPrice]);

  return { busdPrice };
}